import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, PopoverController, Events } from 'ionic-angular';
import { CoBrochurePage } from '../co-brochure/co-brochure';
import { EventsProvider } from '../../providers/events/events';
import { CoBrochureConfirmSentEmailComponent } from '../../components/co-brochure-confirm-sent-email/co-brochure-confirm-sent-email';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';
import { LocationsProvider } from '../../providers/locations/locations';
import { ConfigProvider } from '../../providers/config/config';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the CoEventsBrochureModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-events-brochure-modal',
  templateUrl: 'co-events-brochure-modal.html',
  providers: [CoBrochurePage]
})
export class CoEventsBrochureModalPage {
  filters: any;
  email: string = "";
  pageLocationArray: any;
  pageAgesArray: any;
  eventTypesLength: number;
  locationLength: number;
  clientKeyword: string;
  viewType: string;
  locationList: any;
  locationDisplay: string = 'all branches';
  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public brochure: CoBrochurePage, public toast: ToastAlertsProvider, public eventsProvider: EventsProvider, public popoverCtrl: PopoverController, private clientDetails: ClientDetailsProvider, public state: AppState, public locationsProvider: LocationsProvider, public config: ConfigProvider, private events : Events, private timeoutFunctions : TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeoutFunctions.doLogoutFunctions(this));
    let navs = this.navParams.data;
    this.filters = navs.filters;
    this.filters.dateRange = navs.dateRange;
    navs.filters.ages ? this.pageAgesArray = navs.filters.ages.join(', ') : this.pageAgesArray = 'all ages';
    this.eventsProvider.getEventAgesTypes().then((res) => {
      this.eventTypesLength = res.types.length;
      if (this.filters.eventType && this.eventTypesLength === this.filters.eventType.length) delete this.filters.eventType;
    });
    this.locationsProvider.getLocations().then((res) => {
      this.locationLength = res.length
      this.locationList = res;
      if (this.filters.location && this.filters.location.length === this.locationLength) {
        this.pageLocationArray = 'all branches';
        delete this.filters.location;
      }
    });
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = state.mode;
    });
  }

  ionViewDidLoad() {
  }

  ngOnInit() {
    if ((this.filters.location && this.filters.location.length === this.locationLength) || !this.filters.location){
      this.locationDisplay = 'all branches';
    } else {
      this.locationDisplay = this.matchLocationIDtoName(this.filters.location);
    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  matchLocationIDtoName(list) {
    let outputArray = []
    list.forEach(loc => {
      try {
        let locationObject = this.locationList.find(object => object.id === Number(loc));
        outputArray.push(locationObject.name)
      } catch (ex) {

      };
    });
    return outputArray.join(', ');
  }

  downloadBrochure(){
    if (this.filters.eventType && this.eventTypesLength === this.filters.eventType.length) delete this.filters.eventType;
    if (this.filters.location && this.filters.location.length === this.locationLength) delete this.filters.location;
    this.filters.email = '';
    this.brochure.setBrochureParamsFromInput(this.filters, 'download');
    this.toast.triggerToast("Download will begin shortly!", '', 'success')
    setTimeout(()=>this.viewCtrl.dismiss().catch(err=>{}), 2000)
  }

  close(event) {
    if (this.filters.eventType && this.eventTypesLength === this.filters.eventType.length) delete this.filters.eventType;
    if (this.filters.location && this.filters.location.length === this.locationLength) delete this.filters.location;
    this.filters.email = this.email;
    this.brochure.setBrochureParamsFromInput(this.filters, 'email');
    // this.openConfirmPopover(event);
    setTimeout(()=>this.viewCtrl.dismiss().catch(err=>{}), 2000)
  }

  submitForm(button) {
    // console.log(button)
    // let form = document.getElementById('downloadBrochureForm') as any; REMOVE QUERY SELECTOR
    // form.submit();
  }

  openConfirmPopover(event) {
    let customClass = 'custom-popover-confirm-email';
    let popover = this.popoverCtrl.create(CoBrochureConfirmSentEmailComponent, {}, { cssClass: customClass });
    popover.present({
      ev: event
    });
  }

  closeButton() {
    this.viewCtrl.dismiss().catch(err=>{});
  }

  sendBrochureEmail(event) {
    if (this.email.length > 0) {
      this.close(event);
    } else {
      this.toast.triggerToast('Please enter a valid email address', '')
    }
  }

  goToBrochurePage(){
    this.viewCtrl.dismiss().catch(err=>{});
    // this.config.load(this.state.appId).then(cfg => {
    // });
    this.navCtrl.push(CoBrochurePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-events-brochure-modal/co-events-brochure-modal.ts